import { IconsProps } from './IconsProps';

const ArrowLeftLong = ({
  className = '',
  viewBox = '0 0 24 24',
  width = 24,
  height = 24,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clipPath="url(#a)">
        <path d="M2 12.521v.002c.004.027.01.053.016.08a.686.686 0 0 0 .037.183c.037.09.092.17.161.238L7.88 18.69a.7.7 0 1 0 .99-.99l-4.476-4.476H20.7a.7.7 0 1 0 0-1.4H4.387l4.628-4.628a.7.7 0 1 0-.99-.99l-5.82 5.82a.688.688 0 0 0-.128.194c-.006.011-.017.02-.022.033a.7.7 0 0 0-.055.27Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path transform="rotate(180 10.7 9.447)" d="M0 0h19.4v12.894H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowLeftLong;
